import { AppDefinition } from '../../types/apps';

/**
 * Canonical AppDefinition for Canvas entities. Window appType is `canvas-v2`
 * (see canonicalizeWindowAppType — persisted `canvas` rewrites on load).
 * appId stays `canvas` so icon/create-menu ownership of entityType Canvas
 * does not fork.
 */

export const CANVAS_EVENTS = {
  ELEMENT_ADDED: 'CANVAS_ELEMENT_ADDED',
  ELEMENT_UPDATED: 'CANVAS_ELEMENT_UPDATED',
  ELEMENT_DELETED: 'CANVAS_ELEMENT_DELETED',
  VIEWPORT_CHANGED: 'CANVAS_VIEWPORT_CHANGED',
} as const;

export const CanvasAppDefinition: AppDefinition = {
  appId: 'canvas',
  name: 'Canvas',
  version: '2.0.0',
  description: 'Simple visual workspace - draw, write sticky notes, and organize ideas spatially',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'PaintBrush',
    phosphorWeight: 'duotone',
    color: '#7c3aed',
  },
  entityTypes: ['Canvas'],
  component: 'CanvasApp_v2',
  requiresProps: false,
  requiresEntity: false,
  events: CANVAS_EVENTS,
  agenticToolIds: [
    'canvas_create',
  ],
  hotkeys: {
    'v': 'selectTool',
    't': 'textTool',
    'p': 'pencilTool',
    '+': 'zoomIn',
    '-': 'zoomOut',
    '1': 'fitAll',
  },
};
